import React from "react";
import PropTypes from "prop-types";

export default function AudienceSVG(props) {
  return (
    <svg
      version="1.1"
      id={props.id || ''}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 84.2 70"
      fill={props.styles.fill}
      width={props.styles.width}
      height={props.styles.height}
      className={props.className || ''}
    >
      <g>
        <path
          className="st0"
          d="M78.5,32.9c1.9-0.6,3.2-2.3,3.2-4.3c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5c0,2,1.4,3.8,3.2,4.3V37
		c-2.3,1.2-4.8,2.2-7.5,3.1v-0.8c1.8-1.3,2.8-3.4,2.8-5.6V21c0-3.9-3.2-7-7.1-7s-7,3.2-7,7v12.6c0,2.1,1,4.1,2.6,5.5v3.2
		c-2.3,0.5-4.6,0.8-7,1.1v-4.2c1.8-1.3,2.8-3.4,2.8-5.6V21c0-3.9-3.2-7-7-7s-7,3.2-7,7v12.6c0,2.1,1,4.1,2.6,5.5v5.1
		c-1.3,0-2.6,0.1-3.9,0.1c-1,0-2.1,0-3.1-0.1v-4.9c1.8-1.3,2.8-3.4,2.8-5.6V21c0-3.9-3.2-7-7-7s-7,3.2-7,7v12.6c0,2.1,1,4.1,2.6,5.5
		v4.5c-2.4-0.3-4.7-0.6-7-1.1v-3.2c1.8-1.3,2.8-3.4,2.8-5.6V21c0-3.9-3.2-7-7-7s-7.1,3.2-7.1,7v12.6c0,2.1,1,4.1,2.6,5.5v1.2
		c-2.2-0.7-4.2-1.5-6.2-2.3v-5.1c1.9-0.5,3.2-2.3,3.2-4.3c0-2.5-2-4.5-4.5-4.5S1,26.1,1,28.6c0,2,1.4,3.8,3.2,4.3V62H0v2.5h84.2V62
		h-5.8V32.9H78.5z M75.2,28.6c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S75.2,29.7,75.2,28.6z M61.8,37.4c-1.3-0.8-2-2.3-2-3.8V21
		c0-2.5,2-4.5,4.5-4.5c2.5,0,4.6,2,4.6,4.5v12.6c0,1.6-0.8,3.1-2.2,3.9L66,37.8v2.9c-1.2,0.3-2.4,0.7-3.7,1v-4L61.8,37.4z
		M62.4,44.3c1.2-0.3,2.5-0.6,3.7-0.9v15.5h-3.7C62.4,58.9,62.4,44.3,62.4,44.3z M46.2,37.4c-1.3-0.8-2-2.3-2-3.8V21
		c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5v12.6c0,1.6-0.8,3.1-2.2,3.9l-0.6,0.4v5.9c-1.2,0.1-2.4,0.2-3.7,0.3v-6.2L46.2,37.4z M46.7,46.5
		c1.2-0.1,2.4-0.2,3.7-0.3v12.7h-3.7V46.5z M30.5,37.4c-1.3-0.8-2-2.3-2-3.8V21c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5v12.6
		c0,1.6-0.8,3.1-2.2,3.9l-0.6,0.4V44c-1.2-0.1-2.4-0.2-3.7-0.2v-6L30.5,37.4z M31.1,46.3c1.2,0.1,2.4,0.2,3.7,0.2v12.3h-3.7
		C31.1,58.8,31.1,46.3,31.1,46.3z M14.9,37.4c-1.3-0.8-2.1-2.3-2.1-3.8V21c0-2.5,2-4.5,4.6-4.5s4.6,2,4.6,4.5v12.6
		c0,1.6-0.8,3.1-2.2,3.9l-0.6,0.4V42c-1.2-0.3-2.5-0.6-3.6-0.9v-3.3L14.9,37.4z M15.4,43.6c1.2,0.3,2.4,0.6,3.6,0.9v14.4h-3.6V43.6z
		M3.5,28.6c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S3.5,29.7,3.5,28.6z M6.8,40.7c1.9,0.8,4,1.6,6.2,2.2v18.5h8.6V45
		c2.3,0.4,4.6,0.8,7,1v15.3h8.6V46.7c1,0,2.1,0,3.1,0c1.3,0,2.6,0,3.9-0.1v14.8h8.7V45.9c2.4-0.3,4.7-0.7,7-1.1v16.5h8.7V42.6
		c2.7-0.8,5.2-1.8,7.5-2.9v22.2H6.8V40.7z"
        />
        <path
          className="st0"
          d="M17.5,12.2c3.4,0,6.1-2.7,6.1-6.1S20.9,0,17.5,0s-6.1,2.7-6.1,6.1S14.2,12.2,17.5,12.2z M17.5,2.5
		c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6S14,8.1,14,6.1S15.6,2.5,17.5,2.5z"
        />
        <path
          className="st0"
          d="M33.2,12.2c3.4,0,6.1-2.7,6.1-6.1S36.5,0,33.2,0s-6.1,2.7-6.1,6.1S29.8,12.2,33.2,12.2z M33.2,2.5
		c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6S31.2,2.5,33.2,2.5z"
        />
        <path
          className="st0"
          d="M48.8,12.2c3.4,0,6.1-2.7,6.1-6.1S52.2,0,48.8,0s-6.1,2.7-6.1,6.1S45.5,12.2,48.8,12.2z M48.8,2.5
		c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6S46.9,2.5,48.8,2.5z"
        />
        <path
          className="st0"
          d="M64.5,12.2c3.4,0,6.1-2.7,6.1-6.1S67.8,0,64.5,0c-3.4,0-6.1,2.7-6.1,6.1S61.1,12.2,64.5,12.2z M64.5,2.5
		c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6S62.5,2.5,64.5,2.5z"
        />
        <rect x="8.8" y="67.5" className="st0" width="44.9" height="2.5" />
        <rect x="56.6" y="67.5" className="st0" width="10.8" height="2.5" />
      </g>
    </svg>
  );
}

AudienceSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
